import React, { createContext } from 'react';

const HotKeysContext = createContext({});
const hotKeysContextValue = {};

const HotKeysProvider = ({ children, value }) => {
  // Allow pages to inject a full hotkey API; otherwise provide safe no-op defaults.
  const noop = () => {};
  const defaultValue = {
    updatePlan: noop,
    nextClass: noop,
    nextLocation: noop,
    setDisplayCopyFromModal: noop,
    showCopyToModal: noop,
    getKFlow: noop,
    reloadPlan: noop,
    clearCache: noop,
    toggleCopyPanel: noop,
    toggleTargetPanel: noop,
    toggleGraphPanel: noop,
    toggleHeaderPanel: noop,
    createFuturePlan: noop,
    removeFuturePlan: noop,
    clientBasicData: null,
  };

  return (
    <HotKeysContext.Provider value={hotKeysContextValue}>
      {children}
    </HotKeysContext.Provider>
  );
};

export { HotKeysContext, HotKeysProvider  };
